const SpecialCharType = {
  N41CODE: 'N41CODE',
  FILENAME: 'FILENAME',
  ALL: 'ALL'
}
const SearchType = {
  STYLE_NUMBER: 'STYLE_NUMBER',
  CATEGORY: 'CATEGORY',
  COLOR: 'COLOR',
  COLOR_SIZE: 'COLOR_SIZE',
  COLOR_SIZE_PRICE: 'COLOR_SIZE_PRICE',
  COLORS: 'COLORS',
  COLORS_SIZE: 'COLORS_SIZE',
  COLORS_SIZE_PRICE: 'COLORS_SIZE_PRICE',
  BARCODE: 'BARCODE',
  OFFPRICE: 'OFFPRICE'
}
const PaymentType = {
  CC_NEW: 'CC_NEW',
  CC: 'CC',
  CC_TBD: 'CC_TBD',
  WIRE: 'WIRE',
  CHECK: 'CHECK',
  TERMS: 'TERMS'
}
export const e = {
  SpecialCharType,
  SearchType,
  PaymentType
}
